import { Box, Checkbox, Tooltip } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { fontSize } from '../..';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SampleRecordPopUp from './SampleRecordPopUp';
import { ITable } from '../../redux/_Dataset/types';
import { TAlert } from '../../types/types';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import ConfirmDialog from './ConfirmDialog';
interface ITableNameProps {
  table: ITable;
  onCheckUncheck: (id: string, checked: boolean) => void;
  dbColor: string;
  vendor: string;
}
function TableName({ table, onCheckUncheck, vendor, dbColor }: ITableNameProps) {
  const [hover, setHover] = useState(false);
  const [showTableData, setShowTableData] = useState(false);
  const [open, setOpen] = useState(false);

  const handleCheckUncheck = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    if (table.isFlatFile) return;
    if (!table.isNewTable && !checked){
      setOpen(true)
    }
    else{
      onCheckUncheck(table.id, checked);
    }
    // console.log(event.target);
  };
  return (
    <Box
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        position: 'relative',
        borderRadius: '4px',
        boxShadow: hover ? '0 0 2px 2px #c9c9c9' : 'none',
        mb: 1,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
      }}
    >
      <Checkbox
        sx={{
          '&.Mui-checked': {
            color: `${dbColor}`,
          },
          '&.Mui-disabled': {
            color: '#B1B1B1',
            cursor: 'not-allowed',
            pointerEvents: 'auto',
          },
        }}
        style={{ width: '0.5rem', height: '0.5rem', margin: 'auto 5px auto 0' }}
        size="small"
        // size="1rem"
        // disabled={props.applyRestriction || !props.table.isNewTable}
        checked={table.isSelected}
        onChange={handleCheckUncheck}
        value={table.id}
        disabled={table.isFlatFile}
      />
      <span
        className="ellipsis tableName"
        title={table.table}
        style={{
          fontSize: fontSize.medium,
          width: '10rem',
          display: 'inline-flex',
          flex: 'none',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
      >
        {table.table}
      </span>
      {hover ? (
        <Tooltip
          title="View Table"
          arrow
          placement="right-start"
          style={{ float: 'right' }}
          sx={{ fontSize: '12px' }}
        >
          <VisibilityOutlinedIcon
            className="tableIcon"
            style={{
              position: 'absolute',
              right: '0.2rem',
              width: '1rem',
              height: '1rem',
              cursor: 'pointer',
            }}
            onClick={() => {
              setShowTableData(true);
            }}
          />
        </Tooltip>
      ) : null}
      {showTableData && (
        <SampleRecordPopUp
          open={showTableData}
          onClose={() => {
            setShowTableData(false);
            setHover(false);
          }}
          database={table.database}
          schema={table.schema}
          vendor={vendor}
          recordCount={100}
          workspaceId=""
          connectionId={table.connectionId}
          tablename={table.table}
          flatfileId={table.isFlatFile ? table.flatFileId : null}
        />
      )}

      <ConfirmDialog
        open={open}
        title="Remove Table?"
        message="Removing this table may cause issues in the dependant playbooks of this dataset. Are you sure?"
        confirmText="Remove Table" 
        cancelText="Cancel"
        onConfirm={() => {
          onCheckUncheck(table.id, false)
          setOpen(false)
        }}
        onCancel={() => setOpen(false)}
      />
    </Box>
  );
}
export default TableName;
